module.exports = __webpack_public_path__ + "static/media/icon-speaker-active.067a6ced.svg";